<p-accordionTab (selectedChange)="togglePanel($event)">
	<ng-template pTemplate="header">
		<div class="flex align-items-center justify-content-between w-full -my-3">
			<div class="font-semibold">{{ 'SPECIAL_PLANNING' | translate }}</div>
		</div>
	</ng-template>
	<div class="grid">
		<div class="col-12">
			<p-table #tableSpecialPlanningList dataKey="Id" [value]="specialPlannings"
				(onLazyLoad)="loadSpecialPlannings($event)" [paginator]="true" [totalRecords]="totalRecords"
				[loading]="specialPlanningsLoading" [rows]="specialPlanningsPageSize" [showCurrentPageReport]="true"
				currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true" responsiveLayout="stack">
				<ng-template pTemplate="caption">
					<div class="grid">
						<div [class]="actionLayout('left')">
							<p-button id="addSpecialPlanning" label="{{ 'ADD_SPECIAL_PLANNING' | translate }}"
								(click)="addSpecialPlanning()"
								[disabled]="specialPlanningsMemorySize>=specialPlanningsMaxMemorySize || isActiveTask"
								icon="pi cm-plus" [rounded]="false" [text]="true" severity="primary"
								styleClass="font-bold border-primary">
							</p-button>
						</div>
						<div [class]="actionLayout('center')">
							<div class="flex flex-column justify-content-center gap-2">
								<span class="flex align-items-center justify-content-center">
									<i class="pi cm-memory-storage mr-1"></i>
									{{'MEMORY_USAGE' | translate }}: {{specialPlanningsMemorySize}} /
									{{specialPlanningsMaxMemorySize}}
								</span>
								<p-progressBar [value]="getValueMemory()">
									<ng-template pTemplate="content" let-value>
										<span *ngIf="getValueMemory() > 4">{{ getValueMemory() }} %</span>
									</ng-template>
								</p-progressBar>
							</div>
						</div>
						<!--<div [class]="actionLayout('right')">
							<span class="p-input-icon-left" [class]="dynamicInputSearchWidth()">
								<i class="pi cm-search"></i>
								<input [formControl]="searchFilter" pInputText type="text" id="customers-input-search"
									placeholder="{{ 'SEARCH' | translate }}" [ngClass]="dynamicInputSearchWidth()"
									maxlength="60" />
							</span>
						</div>-->
					</div>
				</ng-template>
				<ng-template pTemplate="header" class="flex align-items-center justify-content-center">
					<tr>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'NAME' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'ACCESS_MODE_EXCLUDE_INCLUDE' |
								translate }}</div>
						</th>
						<!-- OLD VERSION -->
						<th *ngIf="thereIsOldTimeslice">
							<div class="flex align-items-center justify-content-center">{{ 'PERIOD_DETAILS' | translate }}
							</div>
						</th>
						<!-- OLD VERSION -->
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'PROGRAMMING' | translate }}</div>
						</th>
						<!-- OLD VERSION -->
						<th *ngIf="thereIsOldTimeslice">
							<div class="flex align-items-center justify-content-center">{{ 'REPETITION' | translate }}</div>
						</th>
						<!-- OLD VERSION -->
						<th>
							<div class="flex align-items-center justify-content-center"></div>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-specialPlannig>
					<tr>
						<td>
							<span class="p-column-title font-semibold">{{ 'NAME' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ specialPlannig.Name }}</div>
						</td>
						<td>
							<!--  Access -->
							<span class="p-column-title font-semibold">{{ 'ACCESS_MODE_EXCLUDE_INCLUDE' | translate }}</span>
							<div class="flex flex-row justify-content-center align-items-center">
								<p-tag
									[value]="specialPlannig.Access ? ('CONTROL_ACCESS_ENTER' | translate) : ('CONTROL_ACCESS_NOT_ENTER' | translate)"
									[severity]="specialPlannig.Access ? 'success' : 'danger'"></p-tag>
							</div>
						</td>
						<!-- OLD VERSION -->
						<td *ngIf="thereIsOldTimeslice">
							<span class="p-column-title font-semibold">{{ 'PERIOD_DETAILS' | translate }}</span>
							<span
								*ngIf="isOldSpecialPlanning(specialPlannig) && getRepetitionTimeslice(specialPlannig) === 0">{{
								getLabelRepetition(getRepetitionTimeslice(specialPlannig)) }}</span>
							<p-tag *ngIf="isOldSpecialPlanning(specialPlannig) && getRepetitionTimeslice(specialPlannig) !== 0"
								[value]="getLabelRepetition(getRepetitionTimeslice(specialPlannig))"
								[styleClass]="getColorRepetition(getRepetitionTimeslice(specialPlannig))"></p-tag>
						</td>
						<td *ngIf="isOldSpecialPlanning(specialPlannig)">
							<span class="p-column-title font-semibold">{{ 'PROGRAMMING' | translate }}</span>
							<div class="flex align-items-center justify-content-center">
								<div class="flex align-items-center justify-content-center">{{
									getDetailsTimeSpecialPlanning(specialPlannig)
									}}
								</div>
							</div>
						</td>
						<!-- OLD VERSION -->
						<!-- NEW VERSION -->
						<td *ngIf="!isOldSpecialPlanning(specialPlannig)">
							<span class="p-column-title font-semibold">{{ 'PROGRAMMING' | translate }}</span>
							<div class="flex align-items-center justify-content-center" [class]="underTablet() ? 'grid' : ''">
								<div
									[class]="underTablet() ? 'col-12 flex flex-row align-items-center justify-content-end pb-0' : 'flex flex-row'">
									<!--  DATE  -->
									<div class="flex flex-row align-items-center justify-content-center text-center gap-2 px-2">
										{{ "FROM" | translate }}:
										<p class="font-bold">{{ specialPlannig.DtFrom.split('T')[0]}}</p>
									</div>
									<div class="flex flex-row align-items-center justify-content-center text-center gap-2 px-2">
										{{ "TO" | translate }}:
										<p class="font-bold">{{ specialPlannig.DtTo.split('T')[0]}}</p>
									</div>
								</div>
								<!--  TIME  -->
								<div
									[class]="underTablet() ? 'col-12 flex flex-row align-items-center justify-content-end pb-0' : 'flex flex-row'">
									<div class="flex flex-row align-items-center justify-content-center text-center gap-2 px-2">
										{{ "DATE_FROM" | translate }}:
										<p class="font-bold">{{ specialPlannig.DtFrom.split('T')[1]}}</p>
									</div>
									<div class="flex flex-row align-items-center justify-content-center text-center gap-2 px-2">
										{{ "DATE_TO" | translate }}:
										<p class="font-bold">{{ specialPlannig.DtTo.split('T')[1]}}</p>
									</div>
								</div>
							</div>
						</td>
						<!-- NEW VERSION -->
						<!-- OLD VERSION -->
						<td *ngIf="thereIsOldTimeslice">
							<span class="p-column-title font-semibold">{{ 'REPETITION' | translate }}</span>
							<div class="flex align-items-center justify-content-center"
								*ngIf="isOldSpecialPlanning(specialPlannig)">{{
								getTemporaryTimeslice(specialPlannig) }}
							</div>
						</td>
						<!-- OLD VERSION -->
						<td>
							<span class="p-column-title"></span>
							<div class="flex flex-row justify-content-center align-items-center gap-1">
								<p-button pTooltip="{{ 'EDIT' | translate}}" [disabled]="isActiveTask || specialPlannig.Old"
									id="buttonSpecialPlannigEdit-{{specialPlannig.Name}}" tooltipPosition="bottom"
									icon="pi cm-pencil" size="large" (click)="editSpecialPlanning(specialPlannig)"
									[rounded]="false" [text]="true" severity="secondary">
								</p-button>
								<p-button pTooltip="{{ 'DELETE' | translate}}" [disabled]=" isActiveTask"
									id="buttonSpecialPlannigDelete-{{specialPlannig.Name}}" tooltipPosition="bottom"
									icon="pi cm-trash" size="large" (click)="deleteSpecialPlannig(specialPlannig)"
									[rounded]="false" [text]="true" severity="danger">
								</p-button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="12">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</p-accordionTab>
<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>